// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-cotnainer {
  width: 70%;
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  color: #333333;
}
.title-cotnainer span {
  font-family: var(--font-secondary);
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 25px;
}
@media screen and (max-width: 568px) {
  .title-cotnainer span {
    font-size: 28px;
  }
}
@media screen and (max-width: 450px) {
  .title-cotnainer span {
    font-size: 25px;
  }
}
.title-cotnainer img {
  width: 50%;
  height: 19px;
  margin: 14px auto;
}
@media screen and (max-width: 568px) {
  .title-cotnainer img {
    width: 60%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/secondary-title/secondary-title.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AACJ;AAEI;EACI,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAR;AAEQ;EAPJ;IAQQ,eAAA;EACV;AACF;AACQ;EAXJ;IAYQ,eAAA;EAEV;AACF;AACI;EACI,UAAA;EACA,YAAA;EACA,iBAAA;AACR;AACQ;EALJ;IAMQ,UAAA;EAEV;AACF","sourcesContent":[".title-cotnainer {\n    width: 70%;\n    margin: auto;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    text-transform: uppercase;\n    color: #333333;\n\n\n    span {\n        font-family: var(--font-secondary);\n        font-style: normal;\n        font-weight: 500;\n        font-size: 30px;\n        line-height: 25px;\n\n        @media screen and (max-width: 568px) {\n            font-size: 28px;\n        }\n\n        @media screen and (max-width: 450px) {\n            font-size: 25px;\n        }\n    }\n\n    img {\n        width: 50%;\n        height: 19px;\n        margin: 14px auto;\n\n        @media screen and (max-width: 568px) {\n            width: 60%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
